export enum ScreenerEvents {
  GovTrades = 'gov_trades',
  InsiderTrades = 'insider_trades',
  Ipos = 'ipos',
}
